export default __webpack_public_path__ + "static/media/newbie_project2.117bd4d7.jpg";